module.exports = __webpack_public_path__ + "img/gorra_1.076563d9.png";